var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderSteps',{attrs:{"title":"New flight","steps":_vm.steps,"active":_vm.currentStep,"back-path":-1}}),(_vm.currentStep === 0)?[_c('CampaignPeriod',{on:{"step":_vm.getCurrentStep}})]:_vm._e(),(_vm.currentStep === 1)?[_c('Assets')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }